import { useCallback, useMemo } from "react";
import type { XAxisActions, XAxisStore } from "./XAxisProvider.types";
import XAxisStoreContext from "./contexts/XAxisStoreContext";
import XAxisActionsContext from "./contexts/XAxisActionsContext";
import useAreaChart from "../AreaChartProvider/useAreaChartStore/useAreaChartStore";
import ChartHelpers from "helpers/ChartHelpers";

interface XAxisProviderProps {
  children?: React.ReactNode;
}

function XAxisProvider(props: XAxisProviderProps) {
  const { margin, width, xAxis } = useAreaChart();

  const axis = useMemo(() => xAxis[0], [xAxis]);

  const scale = useMemo(() => {
    return ChartHelpers.constructScaleTime({
      data: axis.data || [],
      accessor: (d) => new Date(d),
      margin: margin,
      width: width,
      start: axis.start,
      end: axis.end,
    });
  }, [axis.data, axis.end, axis.start, margin, width]);

  const getXScale = useCallback(() => scale, [scale]);

  const actions = useMemo<XAxisActions>(() => ({ getXScale }), [getXScale]);

  const store = useMemo<XAxisStore>(() => {
    return { xAxis: axis };
  }, [axis]);

  return (
    <XAxisActionsContext.Provider value={actions}>
      <XAxisStoreContext.Provider value={store}>{props.children}</XAxisStoreContext.Provider>
    </XAxisActionsContext.Provider>
  );
}

export default XAxisProvider;
